
import React from "react";
import { Button } from "@/components/ui/button";

interface HeroServiceSectionProps {
  title: string;
  subtitle?: string;
  description: string;
  onButtonClick?: () => void;
  buttonText?: string;
}

export const HeroServiceSection: React.FC<HeroServiceSectionProps> = ({
  title,
  subtitle = "Our Services",
  description,
  onButtonClick,
  buttonText = "Book Appointment",
}) => {
  return (
    <section className="pt-32 pb-20 md:pt-40 md:pb-32 bg-dental-offwhite">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block text-dental-highlight font-medium mb-4 uppercase tracking-wider text-sm">
            {subtitle}
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-semibold mb-6">
            {title}
          </h1>
          <p className="text-lg text-dental-muted">
            {description}
          </p>
          {buttonText && onButtonClick && (
            <div className="mt-8">
              <Button className="btn-primary" onClick={onButtonClick}>
                {buttonText}
              </Button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
